// Sliders Script Start
var swiper = new Swiper(".bannerSlider", {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 1300,
  parallax: true,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  navigation: false,
});
// Products Tabs

window.addEventListener("DOMContentLoaded", () => {
  const tabsNav = document.querySelectorAll(
    ".products-slider-tabs .product-cta-btns a"
  );
  const tabsContent = document.querySelectorAll(
    ".products-slider-tabs .productsSlide"
  );

  tabsNav[0].classList.add("active");
  tabsContent[0].classList.add("active");

  tabsNav.forEach((items, ind) => {
    items.addEventListener("click", () => {
      tabsNav.forEach((remove) => {
        remove.classList.remove("active");
      });
      items.classList.add("active");
      tabsContent.forEach((content) => {
        content.classList.remove("active");
      });
      tabsContent[ind].classList.add("active");
    });
  });
});

// product slider

const MultipleSlider = () => {
  let MultipleSliders = document.querySelectorAll(".swiperCus");
  let prevArrow = document.querySelectorAll(".prev");
  let nextArrow = document.querySelectorAll(".next");
  MultipleSliders.forEach((slider, index) => {
    let sliderLength = slider.children[0].children.length;
    let result = sliderLength > 1 ? false : true;
    const swiper = new Swiper(slider, {
      direction: "horizontal",
      loop: result,
      navigation: {
        nextEl: nextArrow[index],
        prevEl: prevArrow[index],
      },
      breakpoints: {
        200: {
          slidesPerView: 2.3,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 3.3,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 4.3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      speed: 800,
    });
  });
};

window.addEventListener("load", MultipleSlider);

document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll(".accordion-item");
  if (accordionItems.length > 0) {
    accordionItems[0].classList.add("open");
  }
  accordionItems.forEach((item) => {
    const header = item.querySelector(".accordion-item-header");
    header.addEventListener("click", () => {
      document.querySelectorAll(".accordion-item").forEach((otherItem) => {
        if (otherItem !== item && otherItem.classList.contains("open")) {
          otherItem.classList.remove("open");
        }
      });
      item.classList.toggle("open");
    });
  });
});

// Review Slider start ///
jQuery(document).ready(function ($) {
  $(".regular").slick({
    dots: true,
    autoplay: true,
    autoplaySpeed: 9000,
    speed: 700,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    respondTo: "min",
    cssEase: "linear",
    prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>',
  });

  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: false,
    fade: true,
    asNavFor: ".slider-nav",
  });
  $(".slider-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: true,
    centerMode: true,
    focusOnSelect: true,
    autoplay: true,
    centerPadding: "10px",
    prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>',
    responsive: [
      {
        breakpoint: 640,
        settings: {
          dots: false,
          slidesToShow: 1,
        },
      },
    ],
  });
});
// Review Slider end ///

// checking slider

var quoteSwiper = new Swiper(".image-slider", {
  direction: "horizontal",
  slidesPerView: 1,
  allowTouchMove: false,
  parallax: true,
});
var $Speed = 1000;
var imageSwiper = new Swiper(".quote-slider", {
  speed: $Speed,
  slidesPerView: 1,
  spaceBetween: 20,
  longSwipesRatio: 0.01,
  grabCursor: true,
  watchSlidesProgress: true,
  pagination: {
    el: ".swiper-pagination_gell",
    clickable: true,
  },
  lazy: {
    loadPrevNext: true,
  },
});

imageSwiper.controller.control = this.quoteSwiper;
